export default "__VITE_ASSET__Cj4XeILq__"